module.exports = __webpack_public_path__ + "img/img_left_nav_bank.aeb23300.svg";